import axios from 'axios';
import { getToken } from './authStore';

const csrfMeta = () => document.querySelector("meta[name=csrf-token]");

const baseHeaders = {
  Accept: 'application/json, text/javascript',
  credentials: "include",
  'X-CSRF-Token': (csrfMeta() ? csrfMeta().content : null),
};

const withAuth = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  });
  return instance;
};

const httpService = withAuth(axios.create({ headers: baseHeaders }))

const createAxiosInstace = configuration =>
  withAuth(axios.create({
    headers: baseHeaders,
    ...configuration
  }))

export const getRequestMethods = (baseURL, organization_id) => ({
  request: createAxiosInstace({ baseURL }),
  apiRequest: createAxiosInstace({ baseURL: '/api/v4', params: { organization_id } })
})

export const apiServiceVindi = (key) => {
  const headers = { "Authorization": "Basic " + btoa(`${key}:`) }

  return axios.create({
    headers
  })
}

export const apiService = () => {
  const splittedURL = window.location.href.split('/v4')
  if (splittedURL.length === 0) {
    return httpService
  }

  return withAuth(axios.create({
    headers: baseHeaders,
    baseURL: splittedURL[0]
  }))
}

export const getLink = (o, url) => `${getBaseURL(o)}${formatLink(url)}`

export const getBaseURL = o => `/v4/o/${o}/`

const formatLink = link => link.replace(/^\/+/, "")

export const visit = (currentOrganizationIndex, providedLink = '', options = {}) => {
  const spa = options.spa || false;
  const baseURL = getBaseURL(currentOrganizationIndex)
  const link = formatLink(providedLink)
  const finalURL = `${baseURL}${link}`;

  if (spa) {
    window.history.pushState({}, "", finalURL);
    window.dispatchEvent(new PopStateEvent("popstate"));
  } else {
    currentOrganizationIndex != null
      ? Turbolinks.visit(finalURL)
      : Turbolinks.visit("/v4");

  }
}

export const httpServiceNotification = withAuth(axios.create({ headers: baseHeaders }))

export default httpService
